function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgress = function SvgProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    viewBox: "-1 -1 34 34",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.169 16a15.169 15.169 0 0 1-9.364 14.014 15.169 15.169 0 0 1-16.53-3.288 15.169 15.169 0 0 1-3.29-16.531A15.169 15.169 0 0 1 16 .83V16zm0 0a15.169 15.169 0 0 1-15.17 15.169A15.169 15.169 0 0 1 .832 15.999 15.169 15.169 0 0 1 16 .832 15.169 15.169 0 0 1 31.169 16z",
    stroke: "currentColor",
    strokeWidth: 3,
    style: {
      paintOrder: "stroke markers fill"
    },
    fill: "none"
  }));
};
export default SvgProgress;